// Canonical dynamique : https://serenite-essence.fr + chemin propre (sans slash final, sauf la home).
export const SITE_ORIGIN = "https://serenite-essence.fr";

export function canonicalFor(pathname) {
  const clean = (pathname || "/").replace(/\/+$/, "");
  return clean === "" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${clean}`;
}

export function applyCanonical(pathname) {
  if (typeof document === "undefined") return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", canonicalFor(pathname));
}
